import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from "@tanstack/react-query";
interface SocialNetwork {
  facebook: string;
  linkedin: string;
  x: string;
  messaging: string;
}
export const useSocialNetwork = clubSlug => {
  const $ = _c(8);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== clubSlug) {
    t0 = async data => {
      const response = await fetch("/api/club-social-network", {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          clubSlug,
          socialNetwork: data
        })
      });
      if (!response.ok) {
        throw new Error("Erreur lors de la mise \xE0 jour des r\xE9seaux sociaux");
      }
      return await response.json();
    };
    $[0] = clubSlug;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== clubSlug || $[3] !== queryClient) {
    t1 = data_0 => {
      queryClient.setQueryData(["club", clubSlug, "socialNetwork"], data_0.socialNetworks);
    };
    $[2] = clubSlug;
    $[3] = queryClient;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t0 || $[6] !== t1) {
    t2 = {
      mutationFn: t0,
      onSuccess: t1
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useMutation(t2);
};